import {BaseService} from './Core/BaseService';

class ArgGisRestService extends BaseService {
    get Url() { return super.Url + "/arcGisRest"; }

    GetAddressData(search) {
        let request = {
            search: search
        };

        return this.SendRequest(BaseService.GET, request);
    }
}

export const service = new ArgGisRestService();

